module.exports = require('./helpers/bundle-url').getBundleURL('4SxJc') + "json.worker.60a7b66b.js";